var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "service-setting global-page-base-layout" },
    [
      _c(
        "div",
        { staticClass: "add-doc" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.gotoCreate } },
            [_vm._v("添加用户组")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "select-conditions" }, [
        _c(
          "div",
          { staticClass: "select-conditions-row" },
          [
            _c("el-col", { attrs: { span: 12 } }, [
              _c(
                "div",
                { staticClass: "grid-content bg-purple-light" },
                [
                  _vm._v("\r\n            所属仲裁委：\r\n            "),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { size: "medium", placeholder: "请选择" },
                      model: {
                        value: _vm.committeeValue,
                        callback: function ($$v) {
                          _vm.committeeValue = $$v
                        },
                        expression: "committeeValue",
                      },
                    },
                    _vm._l(_vm.committeeArr, function (item, index) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "select-conditions-row",
            staticStyle: { "text-indent": "5em", "margin-top": "25px" },
          },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "medium" },
                on: { click: _vm.screen },
              },
              [_vm._v("筛选")]
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "clear-all", on: { click: _vm.clearAllConditon } },
              [_vm._v("清空筛选条件")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "tooltip-effect": "dark",
                "header-cell-style": { background: _vm.tableHeaderColor },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "ylGroupId", label: "亿联分组ID" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.ylGroupId
                          ? _c("span", { staticClass: "link-style" }, [
                              _vm._v(_vm._s(scope.row.ylGroupId)),
                            ])
                          : _c("span", { staticClass: "link-style" }, [
                              _vm._v("暂未创建分组"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "ylGroupName", label: "分组名称(仲裁委名称)" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { fixed: "right", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.ylGroupId
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "medium" },
                                on: {
                                  click: function ($event) {
                                    return _vm.addUser(scope.row)
                                  },
                                },
                              },
                              [_vm._v("添加用户")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.ylGroupId
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "medium" },
                                on: {
                                  click: function ($event) {
                                    return _vm.getUserList(scope.row)
                                  },
                                },
                              },
                              [_vm._v("查看用户列表\r\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.edit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        !scope.row.ylGroupId
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "medium" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteRow(scope.row)
                                  },
                                },
                              },
                              [_vm._v("删除\r\n            ")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-sizes": _vm.pageSizes,
                  "page-size": 10,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "庭审用户组编辑",
            visible: _vm.sourceVisible,
            width: "50%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.sourceVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "temForm",
              attrs: {
                model: _vm.temForm,
                "label-position": "left",
                "label-width": "120px",
                rules: _vm.temFormRules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "归属仲裁委", prop: "commId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "85%" },
                      attrs: { size: "medium", placeholder: "请选择仲裁委" },
                      model: {
                        value: _vm.temForm.commId,
                        callback: function ($$v) {
                          _vm.$set(_vm.temForm, "commId", $$v)
                        },
                        expression: "temForm.commId",
                      },
                    },
                    _vm._l(_vm.committeeArr, function (item, index) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "庭审纪律", prop: "discipline" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "85%" },
                    attrs: {
                      type: "textarea",
                      rows: "10",
                      placeholder: "请填写庭审纪律",
                    },
                    model: {
                      value: _vm.temForm.discipline,
                      callback: function ($$v) {
                        _vm.$set(_vm.temForm, "discipline", $$v)
                      },
                      expression: "temForm.discipline",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.sourceVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.groupUserLoading },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("temForm")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "庭审用户添加",
            visible: _vm.groupUserVisible,
            width: "50%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.groupUserVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "groupUserForm",
              attrs: {
                model: _vm.groupUserForm,
                "label-position": "left",
                "label-width": "120px",
                rules: _vm.groupUserFormRules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "仲裁员", prop: "sysUserId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "85%" },
                      attrs: { size: "medium", placeholder: "请选择仲裁员" },
                      on: {
                        change: function ($event) {
                          return _vm.groupUserChange(
                            _vm.groupUserForm.sysUserId
                          )
                        },
                      },
                      model: {
                        value: _vm.groupUserForm.sysUserId,
                        callback: function ($$v) {
                          _vm.$set(_vm.groupUserForm, "sysUserId", $$v)
                        },
                        expression: "groupUserForm.sysUserId",
                      },
                    },
                    _vm._l(_vm.arbitrationArr, function (item, index) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "手机", prop: "mobile" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "85%" },
                    attrs: { type: "text", placeholder: "请填写手机" },
                    model: {
                      value: _vm.groupUserForm.mobile,
                      callback: function ($$v) {
                        _vm.$set(_vm.groupUserForm, "mobile", $$v)
                      },
                      expression: "groupUserForm.mobile",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "邮箱", prop: "email" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "85%" },
                    attrs: { type: "text", placeholder: "请填写手机" },
                    model: {
                      value: _vm.groupUserForm.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.groupUserForm, "email", $$v)
                      },
                      expression: "groupUserForm.email",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.groupUserVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.groupUserLoading },
                  on: {
                    click: function ($event) {
                      return _vm.submitUserForm("groupUserForm")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "用户列表",
            visible: _vm.abirtUserVisible,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.abirtUserVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.abirtGridData } },
            [
              _c("el-table-column", {
                attrs: { property: "name", label: "用户名称" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { property: "mobile", label: "手机" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { property: "email", label: "邮箱" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { property: "ylTitle", label: "显示名称" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { fixed: "right", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteUserRow(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除\r\n            ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.abirtUserVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }